import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { api, unwrap } from '~/lib/api'

export const calendarKeys = { all: ['calendar'] as const }

export const calendarQuery = (teamId: string, season: string, from: string, to: string) =>
  queryOptions({
    queryKey: ['calendar', teamId, season, 'events', from, to],
    // Club-wide entries come with every team; other teams' sessions only when no team is selected.
    queryFn: () => unwrap(api.calendar.$get({ query: { from, to, ...(teamId ? { teamIds: teamId } : {}) } })),
  })

export type CalendarData = Awaited<ReturnType<NonNullable<ReturnType<typeof calendarQuery>['queryFn']>>>
export type CalendarItem = CalendarData['items'][number]

export const feedsQuery = queryOptions({
  queryKey: ['calendar', 'feeds'],
  queryFn: () => unwrap(api.calendar.feeds.$get()),
})

export function useCreateFeed() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: { label?: string | null; scope: { teamIds?: string[]; kinds?: ('match' | 'training' | 'meeting' | 'club_event' | 'booking')[] } }) =>
      unwrap(api.calendar.feeds.$post({ json: body })),
    onSuccess: () => qc.invalidateQueries({ queryKey: feedsQuery.queryKey }),
  })
}

export function useRevokeFeed() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => unwrap(api.calendar.feeds[':id'].$delete({ param: { id } })),
    onSuccess: () => qc.invalidateQueries({ queryKey: feedsQuery.queryKey }),
  })
}
